var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"justify-content"},[_c('a',{on:{"click":_vm.editBite}},[_c('Icon',{staticClass:"text-primary text-center mx-2 font-size-md",attrs:{"icon":"pen","alt":"Edit"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }